"use client";

import { useTranslations } from "next-intl";

const STEPS = Array.from({ length: 10 }, (_, i) => ({
	titleKey: `processStep${i + 1}Title` as const,
	descKey: `processStep${i + 1}Desc` as const,
}));

export default function MetalCastingProcess() {
	const t = useTranslations("new-metal-casting");

	return (
		<section className="bg-[#fcfff4] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("processTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("processDesc")}</p>
				</header>

				<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
					{STEPS.map((step, index) => (
						<article
							key={step.titleKey}
							className="relative mt-8 flex flex-col items-center rounded-xl bg-[#ffffff] px-5 pb-5 pt-10 text-center shadow-card"
						>
							<div className="absolute -top-8 flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-[#64a525] text-2xl font-bold text-white">
								{index + 1}
							</div>
							<h3 className="mb-2 text-base font-bold text-[#64a525] sm:text-lg">{t(step.titleKey)}</h3>
							<p className="text-xs leading-relaxed text-black sm:text-sm">{t(step.descKey)}</p>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
